import React from 'react';

import { ApolloProvider } from '@apollo/client';
import { init } from 'Libs/apollo';
import { GlobalStyle, AppStyled } from '../GlobalStyle';
import AuthStore from 'Store/AuthStore';
import InitiStore from 'Store/InitiStore';
import UiStore from 'Store/UiStore';

import PreferenceCenter from 'Components/PreferenceCenter/Preference';
import ModalContainer from 'react-modal-promise';
import DesignStore from 'Store/DesignStore';
import { DynamicStyles } from 'Components/DynamicStyles';
import { DynamicStylesExternal } from 'Components/DynamicStylesExternal';

export default () => {
  const client = init();

  return (
    <AppStyled>
      <AuthStore.Provider initialData={client}>
        <UiStore.Provider>
          <DesignStore.Provider initialData={client}>
            <ApolloProvider client={client}>
              <InitiStore />
              <DynamicStylesExternal />
              <GlobalStyle />
              <PreferenceCenter />
              <ModalContainer />
            </ApolloProvider>
          </DesignStore.Provider>
        </UiStore.Provider>
      </AuthStore.Provider>
    </AppStyled>
  );
};
